import {getDow, parseDate, sameDate} from "../../utils/date-object";

export const AcceptableFulfillmentDate = ({holidays}) => {
    const holidays1 = (holidays??[]).map(parseDate);
    return (d) => {
        const dow = getDow(d);

        if (dow === 0 || dow === 6) {
            return false;
        }

        if (holidays1.find((d1) => sameDate(d1, d))) {
            return false;
        }
        return true;
    };
};
